(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/views/prolong.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/views/prolong.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.maltipset.views.Prolong = Backbone.Marionette.View.extend({
    regions: {
      prolongList: '.prolong-list-wrap'
    },
    template: function(data) {
      return svs.maltipset.templates.prolong(data);
    },
    className: 'maltipset-prolong padding-1',
    onRender: function() {
      var self = this;
      this.prolongListView = new svs.maltipset.views.ProlongList({
        collection: this.collection
      });
      this.getRegion('prolongList').show(this.prolongListView);
      if (!svs.core.detect.formfactor.mobile()) {
        this.collection.on('sync', function() {
          self.trigger('modalContentResize');
        });
      }
      this.on('reachedend', function() {
        self.prolongListView.onScrollEnd();
      });
    },
    onClose: function() {
      this.prolongListView.destroy();
    }
  });
})(Backbone, _, svs);

 })(window);